export const getFullName = (user: UserInfo | undefined):string => {
  if (user?.firstName) {
    return `${user?.firstName} ${user?.lastName || ''}`.trim();
  }
  
  return user?.id || '';
};
